import React from 'react';
import ReactDOM from 'react-dom/client';
import 'assets/fonts/Noto-Sans.css'
import 'assets/fonts/Noto-Sans-Mono.css'
import App from './pages';
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material'
import defaultTheme from './styles/theme';
import globalStyles from './styles/global-styles';
import { MainStoreProvider } from 'store';
import { DialogStoreProvider } from 'dialogs';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <MainStoreProvider>
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline/>
      <GlobalStyles styles={globalStyles} />
      <DialogStoreProvider>
        <App />
      </DialogStoreProvider>
    </ThemeProvider>
  </MainStoreProvider>
);
